import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.includedProductHierarchy === undefined ||
  widgetSetting.includedProductHierarchy === null ||
  widgetSetting.includedProductHierarchy.length === 0

const isOverMaxInput = () => false

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => ({
  ...widgetSetting,
  includedProductHierarchy: insights
    .map((i) => {
      const splitedSearchName = i.searchName?.split('+') || []
      return splitedSearchName?.map((z) => [z])
    })
    .flat()
})

const generateIncludedProductHierarchyMultipleAndStrategy = (): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput,
  composeDrillDownWidgetSetting
})

export default generateIncludedProductHierarchyMultipleAndStrategy
